// A customer's own resume position, kept in this browser only — distinct
// from `components/Education/education-audio-progress.ts`'s throttled
// reporter, which decides how often `onProgress` fires so the *server* (and
// through it, the lead's History) hears about playback. This is purely
// local: reload the guide page and the player picks up where the same
// browser left off, keyed by the edition's `public_id` so switching editions
// never resumes into the wrong one.
const STORAGE_PREFIX = "ezbuild.projectEducation.audioPosition."

/** Storage can throw (private browsing, blocked site data, a full quota) —
 *  every caller treats that exactly like "nothing stored", never an error. */
export const getStoredAudioPositionMs = (publicId: string): number => {
  try {
    const raw = window.localStorage.getItem(`${STORAGE_PREFIX}${publicId}`)
    const parsed = raw ? Number(raw) : 0
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
  } catch {
    return 0
  }
}

export const storeAudioPositionMs = (publicId: string, positionMs: number): void => {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${publicId}`, String(Math.round(positionMs)))
  } catch {
    // Without storage the player still works; only cross-reload resume is lost.
  }
}
